import React from "react";
import Table from "antd/lib/table";
import { Column } from "@shared/antd/table";
import { FormattedMessage, useIntl } from "react-intl";
import { useFormFilterHook } from "../../hooks";

interface LearningTableComponentProps {
  data: any;
  columns: any;
  rowSelection?: any;
  handleChange: any;
  pagination: any;
}

export const LearningTableComponent = (props: LearningTableComponentProps) => {
  const { data, columns, rowSelection, handleChange, pagination } = props;
  const intl = useIntl();
  const { content, filteringArray } = useFormFilterHook({ data, intl });
  return (
    <>
      <Table
        dataSource={filteringArray}
        rowSelection={rowSelection}
        useFixedHeader={true}
        bodyStyle={{ overflowY: "scroll", height: "320px" }}
        rowKey={"id"}
        onChange={handleChange}
        pagination={pagination}
      >
        {columns.map(({ title, ...rest }: any) => (
          <Column
            key={title}
            title={<FormattedMessage id={title} />}
            filterDropdown={(props) => content(props, rest.dataIndex, title)}
            {...rest}
          />
        ))}
      </Table>
    </>
  );
};
